module.exports = __webpack_public_path__ + "static/heatmaps1-73de4aad97d1a0f5aa73e2294683a9a6.png";